import {Component, OnInit, Output, EventEmitter, Input, OnChanges} from '@angular/core';
import {Select} from '@ngxs/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {UpdateAddressEvent} from '../../../event-listeners/update-address/update-address.event';
import {LocalStorageManager} from '../../../../../data/manager/local-storage/local-storage.manager';
import { countryConfig } from 'src/country-config/country-config';
import { DynamicYieldManager } from 'src/app/data/manager/dynamic-yield/dynamic-yield.manager';

@Component({
  selector: 'app-address-user',
  templateUrl: './address-user.component.html',
  styleUrls: ['./address-user.component.scss'],
})
export class AddressUserComponent implements OnInit, OnChanges {
  user;
  documentNumber;
  customerCall = false;
  address;
  addresses;
  @Select(state => state.addressStore) addressStore$: Observable<any>;
  @Input() callCenterCustomer;
  @Input() icon;
  @Output() logOut = new EventEmitter();

  get addressText() {
    return this.address ? this.address.address : 'Seleccione';
  }
  public christmas: boolean = countryConfig.christmas;

  constructor(private addressEvent: UpdateAddressEvent,
              private lsm: LocalStorageManager, 
              private dynamicYieldManager: DynamicYieldManager) { }

  ngOnInit() {
    this.addressStore$.pipe(map(status => status.addresses)).subscribe(addresses => {
      if (addresses) {
        if (this.addresses && addresses.length < this.addresses.length) {
          const address = addresses.filter(
            a => a.idAddress.toString() === this.address.idAddress.toString(),
          )[0];
          if (!address) {
            this.address = null;
            this.addressEvent.changeAddress(this.address, 'AddressUserComponent[ngOnInit]');
          }
        }
        this.addresses = addresses;
      }
    });
    this.addressEvent.updatedAddress
      .subscribe(address => {
        if (address) {
          this.address = address;
          this.dynamicYieldManager.setCityContextDY(address?.cityName);
        } else {
          this.lsm.removeItem('deliveryAddress');
          this.address = null
        }
      });
  }

  verifyCustomerCallCenter() {
    const customer = this.callCenterCustomer ? this.callCenterCustomer : this.lsm.get('customerCallCenter');
    if (customer?.documentNumber) {
      this.documentNumber = customer.documentNumber;
      this.customerCall = true;
    }
  }

  closeSession() {
    this.customerCall = false;
    this.documentNumber = undefined;
    this.callCenterCustomer = undefined;
    this.logOut.emit(true);
  }

  ngOnChanges(): void {
    this.verifyCustomerCallCenter();
  }
}
